import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthRouteSegments } from 'src/app/shared/constants';
import { ResetPasswordAdapterService } from 'src/app/shared/services/reset-password-adapter/reset-password-adapter.service';

export const resetPasswordGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const resetPasswordAdapter = inject(ResetPasswordAdapterService);

  return resetPasswordAdapter
    .canResetPassword(route)
    .pipe(
      map(
        (canResetPassword) =>
          canResetPassword || router.createUrlTree([AuthRouteSegments.auth, AuthRouteSegments.login]),
      ),
    );
};
